var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeAndSalesIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2 5h1v2h2v1h-3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.5 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.162 2.464A2 2 0 0 0 0 4.28V14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V4.28a2 2 0 0 0-1.162-1.816L7.338.387a2 2 0 0 0-1.676 0zM12 14V4.28a1 1 0 0 0-.58-.908l-4.5-2.077a1 1 0 0 0-.84 0l-4.5 2.077A1 1 0 0 0 1 4.28V14a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1",
  clipRule: "evenodd"
})));
export default SvgTimeAndSalesIcon;